import { DictionaryItemContent } from "../../components/config";

export default function DictionaryItem() {
  return (
    <>
      <DictionaryItemContent />
    </>
  );
}
